import bcrypt from "bcryptjs";

/**
 * bcrypt cost factor for `client_secret_hash`.
 *
 * 12 rounds → ~150ms verify on typical Vercel Node lambdas. The OAuth
 * exchange path already does multiple DB round-trips, so adding ~150ms is
 * negligible compared to the security upgrade over a fast SHA-256.
 */
export const CLIENT_SECRET_BCRYPT_COST = 12;

/**
 * Hashes a plaintext OAuth `client_secret` with bcrypt (cost 12).
 * Used at App-create and rotate time. The plaintext is not retained.
 */
export function hashClientSecret(plaintext: string): Promise<string> {
  return bcrypt.hash(plaintext, CLIENT_SECRET_BCRYPT_COST);
}

/**
 * Computes the 8-char prefix the same way `generateAppClientCredentials`
 * does: take the random portion AFTER the literal `secret_` prefix, then
 * the first 8 chars. If the plaintext doesn't carry the `secret_` prefix
 * (e.g. an admin pasted just the random hex), fall back to the first 8
 * chars of the raw value.
 */
export function computeClientSecretPrefix(plaintext: string): string {
  const raw = plaintext.startsWith("secret_")
    ? plaintext.slice("secret_".length)
    : plaintext;
  return raw.slice(0, 8);
}
